import { render, staticRenderFns } from "./xjevaluation.vue?vue&type=template&id=4ff2209a&scoped=true&"
import script from "./xjevaluation.vue?vue&type=script&lang=js&"
export * from "./xjevaluation.vue?vue&type=script&lang=js&"
import style0 from "./xjevaluation.vue?vue&type=style&index=0&id=4ff2209a&scoped=true&lang=scss&"
import style1 from "./xjevaluation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff2209a",
  null
  
)

export default component.exports